module.exports = __webpack_public_path__ + "img/chest-art.86b4d5ae.webp";